// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import { useQuery } from "@apollo/client";
import PropTypes from "prop-types";

import { useSnackbar } from "../../contexts/snackbar";
import { Loading } from "../Loading";

export const Fetcher = ({ children, errorMessage, query, variables }) => {
  const { addAlert } = useSnackbar();
  const { loading, error, data, refetch } = useQuery(query, {
    variables,
  });

  if (loading) {
    return <Loading />;
  }

  if (error) {
    addAlert(errorMessage);
    return null;
  }

  return React.Children.map(children, (child) => {
    return React.cloneElement(child, {
      data,
      refetch,
    });
  });
};

Fetcher.defaultProps = {
  errorMessage: "Não foi possível exibir suas informações",
};

Fetcher.propTypes = {
  errorMessage: PropTypes.string,
  query: PropTypes.object.isRequired,
  variables: PropTypes.object,
};
